import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface NeonBorderProps {
  children: ReactNode;
  color?: 'green' | 'cyan' | 'purple';
  className?: string;
  animate?: boolean;
}

const colorClasses = {
  green: 'border-cyber-green shadow-[0_0_10px_rgba(0,255,65,0.3),inset_0_0_10px_rgba(0,255,65,0.1)]',
  cyan: 'border-cyber-cyan shadow-[0_0_10px_rgba(0,240,255,0.3),inset_0_0_10px_rgba(0,240,255,0.1)]',
  purple: 'border-cyber-purple shadow-[0_0_10px_rgba(191,0,255,0.3),inset_0_0_10px_rgba(191,0,255,0.1)]',
};

const hoverColorClasses = {
  green: 'hover:shadow-[0_0_20px_rgba(0,255,65,0.5),inset_0_0_20px_rgba(0,255,65,0.2)]',
  cyan: 'hover:shadow-[0_0_20px_rgba(0,240,255,0.5),inset_0_0_20px_rgba(0,240,255,0.2)]',
  purple: 'hover:shadow-[0_0_20px_rgba(191,0,255,0.5),inset_0_0_20px_rgba(191,0,255,0.2)]',
};

export function NeonBorder({ children, color = 'green', className = '', animate = true }: NeonBorderProps) {
  return (
    <motion.div
      className={`
        border-2 rounded-lg bg-cyber-card transition-shadow duration-300
        ${colorClasses[color]}
        ${hoverColorClasses[color]}
        ${className}
      `}
      whileHover={animate ? { scale: 1.02 } : undefined}
      transition={{ type: 'spring', stiffness: 300 }}
    >
      {children}
    </motion.div>
  );
}
